import { useState, useEffect } from "react"
import ChangePassword from "./account/ChangePassword"
import WithdrawalPin from "./account/WithdrawalPin"

const tabList = [
  { id: 1, tab: "Change Password", onClick: "change-password" },
  { id: 2, tab: "Withdrawal Pin", onClick: "withdrawal-pin" },
]
export default function AccountSecurity({ onClose }) {
  const [activeSection, setActiveSection] = useState("change-password")
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])
  return (
    <div className="openProfileItems-container">
      {windowWidth <= 840 && (
        <div className="close-profile-module-container">
          <div className="profile-logo">
            <a href="/">
              <img src="/images/icon/fgh-logo.webp" alt="" />
            </a>
          </div>
          <button className="close-profile-module-btn" onClick={onClose}>
            <img src="/images/icon/ARROW.webp" alt="" /> Back
          </button>
        </div>
      )}
      <div className="change-password-content">
        <div className="openProfile-Label">Account Security</div>
        <div className="wallet-section-3">
          <ul className="profile-tablist">
            {tabList.map((data) => (
              <li
                key={data.id}
                onClick={() => setActiveSection(data.onClick)}
                className={activeSection === data.onClick ? "active" : ""}
              >
                {data.tab}
              </li>
            ))}
          </ul>
          {activeSection === "change-password" && <ChangePassword />}
          {activeSection === "withdrawal-pin" && <WithdrawalPin />}
        </div>
      </div>
    </div>
  )
}
